import React from 'react';
import Head from 'next/head';
import Image from 'next/image';

const Maintenance = () => (
    <>
        <Head>
            <title>Wartungsarbeiten - 10 Finger Schreiben Lernen</title>
            <meta name="description" content="Unsere Website wird derzeit gewartet. Wir sind in Kürze wieder online. Danke für deine Geduld." />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="icon" href="/favicon.ico" />
        </Head>
        <header className="bg-white text-gray-900 p-4 shadow-md">
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex items-center">
                    <Image src="/images/logo.png" alt="Logo" width={40} height={40} />
                    <h1 className="text-xl font-bold ml-2">
                        <a>10-finger-schreiben-lernen.de</a>
                    </h1>
                </div>
            </div>
        </header>
        <section className="bg-white text-center px-10 py-20">
            <div className="container mx-auto">
                <div className="flex justify-center mb-10">
                    <Image src="/images/Repairing.png" alt="Maintenance Image" width={400} height={300} />
                </div>
                <h1 className="text-5xl font-semibold mb-4" style={{fontFamily: '"Courier Prime", monospace'}}>
                    Wir sind bald wieder da!<span className="blinking-cursor">|</span>
                </h1>
                <p className="text-lg mb-4">
                    Unsere Website wird derzeit gewartet. Wir sind in Kürze wieder online.
                    Danke für deine Geduld.
                </p>
            </div>
        </section>
    </>
);

export default Maintenance;
